export default class Collapsible {
    constructor(element) {
        this.element = element;
        this.trigger = element.querySelector('.collapsible__trigger');
        this.content = element.querySelector('.collapsible__content');

        this.init();
    }

    init() {
        if (!this.trigger || !this.content) return;

        // Проверяем начальное состояние
        if (this.element.classList.contains('collapsible--expanded')) {
            this.content.style.maxHeight = this.content.scrollHeight + 'px';
        }

        // Добавляем обработчик события
        this.trigger.addEventListener('click', () => this.toggle());

        // Обновляем высоту при изменении размера окна
        window.addEventListener('resize', () => this.handleResize());
    }

    toggle() {
        if (this.element.classList.contains('collapsible--expanded')) {
            this.collapse();
        } else {
            this.expand();
        }
    }

    expand() {
        this.element.classList.add('collapsible--expanded');
        this.content.style.maxHeight = this.content.scrollHeight + 'px';

        // После завершения анимации убираем inline стиль
        this.content.addEventListener('transitionend', () => {
            if (this.element.classList.contains('collapsible--expanded')) {
                this.content.style.maxHeight = 'none';
            }
        }, { once: true });
    }

    collapse() {
        this.content.style.maxHeight = this.content.scrollHeight + 'px';

        // Небольшая задержка для запуска анимации
        setTimeout(() => {
            this.element.classList.remove('collapsible--expanded');
            this.content.style.maxHeight = '0';
        }, 10);
    }

    handleResize() {
        if (this.element.classList.contains('collapsible--expanded')) {
            this.content.style.maxHeight = 'none';
            setTimeout(() => {
                this.content.style.maxHeight = this.content.scrollHeight + 'px';
            }, 10);
        }
    }
}

// Инициализация всех collapsible элементов на странице
export function initCollapsibles() {
    const elements = document.querySelectorAll('.collapsible');
    const instances = [];

    elements.forEach(element => {
        instances.push(new Collapsible(element));
    });

    return instances;
}